import Link from 'next/link';
import { createColumnHelper } from '@tanstack/react-table';

import Badge from '@/components/Badge';

import {formatDate, formatDateTimeInCst} from '@/services/dates';

export type DashboardCpp = {
	id: number;
	clientGuid: string;
	agent: string;
	clientName: string;
	quoteNumber: number;
	statusId: number;
	coverageId: number;
	programId: number;
	applicantGuid: number;
	underwriterGuid: number;
	inactive: boolean;
	inactiveBy: string;
	inactiveDt: string;
	isMidterm: boolean;
	lastModified: string;
	lastModifiedBy: string;
	quoteEffectiveDate: string;
	quoteNeededDate: string;
	applicationToDoCount: number;
	applicationsCount: number;
	questionnairesCount: number;
	attachmentsCount: number;
	applications: any[];
	applicationToDos: any[];
	applicationAttachments: any[];
	applicationHistories: any[];
};

const columnHelper = createColumnHelper<DashboardCpp>();

const dashboardColumns = [
	columnHelper.accessor( ( row: any ) => row.displayId ? row.displayId : row.id, {
		id: 'id',
		cell: info => (
			<>
				<Link href={ `/cpp/?cppId=${ info.row.original.id }` } className="font-bold text-rural-red-900">
					{ info.getValue() }
				</Link>

				{ info.row.original.isMidterm && (
					<Badge status="neutral">Amend</Badge>
				)}

				{ info.row.original.inactive && (
					<Badge status="neutral">Inactive</Badge>
				)}
			</>
		),
		header: () => 'Application ID',
		enableSorting: true
	}),
	columnHelper.accessor( 'clientName', {
		cell: info => info.getValue(),
		header: () => 'Client name',
		enableSorting: true
	}),
	columnHelper.accessor( 'clientGuid', {
		cell: info => info.getValue(),
		header: () => 'Client number',
		enableSorting: true
	}),
	// columnHelper.accessor( 'quoteNumber', {
	// 	cell: info => info.getValue(),
	// 	header: () => 'Quote number'
	// }),
	columnHelper.accessor( 'lastModified', {
		cell: info => formatDateTimeInCst( info.getValue() ),
		header: () => 'Last modified',
		enableSorting: true
	}),
	columnHelper.accessor( 'quoteEffectiveDate', {
		cell: info => formatDate( info.getValue() ),
		header: () => 'Effective date',
		enableSorting: true
	}),
	columnHelper.accessor( 'agent', {
		cell: info => info.getValue(),
		header: () => 'Agent',
		enableSorting: true
	}),
	columnHelper.display({
		id: 'actions',
		cell: props => (
			<Link href={ `/cpp/?cppId=${ props.row.original.id }` } className="text-rural-red-900">
				{ props.row.original.inactive ? 'View' : 'Manage' }
			</Link>
		)
	})
];

export { dashboardColumns };
